const angular = require('angular');

//this directive compile the given string and insert it as child of the element
//I have found here : http://stackoverflow.com/a/17426614/5866184
//example : <div compile="text"> with $scope.text = '<a ng-click="action()"></a>'

angular.module('atlasDemo').directive('compile', ['$compile', function ($compile) {
    return function(scope, element, attrs) {
        scope.$watch(
            function(scope) {
                // watch the 'compile' expression for changes
                return scope.$eval(attrs.compile);
            },
            function(value) {
                // when the 'compile' expression changes
                // assign it into the current DOM
                element.html(value);

                // compile the new DOM and link it to the current
                // scope.
                // NOTE: we only compile .childNodes so that
                // we don't get into infinite loop compiling ourselves
                $compile(element.contents())(scope);
            }
        );
    };
}]);
